import * as PIXI from 'pixi.js';
import {ADS_TYPE} from "../Ads/AdsType";

export enum CrazyGamesAdsType {
    reward = 'rewarded',
    interstitial = 'midgame',
    banner_728x90 = '728x90',
    banner_300x250 = '300x250',
    banner_320x50 = '320x50',
    banner_468x60 = '468x60',
    banner_320x100 = '320x100'
}

export const CrazyGamesAdsAssoc = {
    [ADS_TYPE.INTERSTITIAL]: CrazyGamesAdsType.interstitial,
    [ADS_TYPE.REWARDED]: CrazyGamesAdsType.reward,
    [ADS_TYPE.BANNER]: CrazyGamesAdsType.banner_728x90,
}

export class CrazyGamesAds extends PIXI.utils.EventEmitter {
    private _sdk: any;

    private _adsStartedBind: () => void;
    private _adsFinishedBind: () => void;
    private _adsErrorBind: () => void;
    private _adsBannerRenderedBind: () => void;
    private _adsBannerErrorBind: () => void;

    private _adblockDetectionBind: () => void;

    public onStarted: () => void = null;
    public onFinished: () => void = null;
    public onError: (e?: {error?: string}) => void = null;

    public hasAdBlock: boolean = false;
    public isBannerVisible: boolean = false;

    private _bannerType: CrazyGamesAdsType;
    private _bannerRefreshTime: number = 60;// seconds
    private _bannerRefreshIntervalId: number = -1;

    constructor() {
        super();

        if (!window['CrazyGames']) {
            return;
        }
        this._sdk = window['CrazyGames'].CrazySDK.getInstance();

        this._adsStartedBind = this._adsStarted.bind(this);
        this._adsFinishedBind = this._adsFinished.bind(this);
        this._adsErrorBind = this._adsError.bind(this);
        this._adsBannerRenderedBind = this._adsBannerRendered.bind(this);
        this._adsBannerErrorBind = this._adsBannerError.bind(this);
        this._adblockDetectionBind = this._adblockDetection.bind(this);

        this._sdk.addEventListener('adblockDetectionExecuted', this._adblockDetectionBind);

        this._sdk.init();

        this._sdk.addEventListener('adStarted', this._adsStartedBind);
        this._sdk.addEventListener('adFinished', this._adsFinishedBind);
        this._sdk.addEventListener('adError', this._adsErrorBind);

        this._sdk.addEventListener('bannerRendered', this._adsBannerRenderedBind);
        this._sdk.addEventListener('bannerError', this._adsBannerErrorBind);

        function adblockDetection(event) {
            if (event.hasAdblock) {
                console.log('User is using an adblocker');
            } else {
                console.log('User is NOT using an adblocker');
            }
        };

        const crazysdk = window.CrazyGames.CrazySDK.getInstance();
    }

    public release(): void {
        if (!this._sdk) {
            return;
        }

        this._sdk.removeEventListener('adStarted', this._adsStartedBind);
        this._sdk.removeEventListener('adFinished', this._adsFinishedBind);
        this._sdk.removeEventListener('adError', this._adsErrorBind);
    }

    public requestAd(type: CrazyGamesAdsType = CrazyGamesAdsType.reward, now: boolean = false): boolean {
        if (this._sdk) {
            try {
                if (type === CrazyGamesAdsType.reward || type === CrazyGamesAdsType.interstitial) {
                    this._sdk.requestAd(type);
                } else {
                    if (!now && this.isBannerVisible) {
                        return false;
                    }

                    const el = document.getElementById( 'banner-container');
                    if (el) {
                        const [w, h] = type.split('x');

                        el.style.visibility = 'visible';
                        el.style.width = w + 'px';
                        el.style.height = h + 'px';
                    }

                    this._bannerType = type;

                    this._sdk.requestBanner([{ size: type, containerId: 'banner-container' }]);
                    this.startBannerRefresh();

                    this.isBannerVisible = true;
                }
                return true;
            } catch (e) {
                return false;
            }

        }
        return false;
    }

    public clearAllBanners(): void {
        if (this._sdk) {
            try {
                this._sdk.clearAllBanners();
            }catch (e) { }
        }

        this.isBannerVisible = false;
        this.stopBannerRefresh();
    }

    public clearBanner(containerId: string =  'banner-container'): void {
        if (this._sdk) {
            try {
                const el = document.getElementById(containerId);
                if (el) {
                    el.style.visibility = 'hidden';
                }

                this._sdk.clearBanner(containerId);
            }catch (e) { }
        }

        this.isBannerVisible = false;
        this.stopBannerRefresh();
    }

    private startBannerRefresh(): void {
        this.stopBannerRefresh();

        this._bannerRefreshIntervalId = setInterval(() => this.requestAd(this._bannerType, true), this._bannerRefreshTime * 1000) as any;
    }

    private stopBannerRefresh(): void {
        console.log('stopBannerRefresh', this._bannerRefreshIntervalId)

        if (this._bannerRefreshIntervalId) {
            clearInterval(this._bannerRefreshIntervalId);
            this._bannerRefreshIntervalId = -1;
        }
    }

    public gameplayStart(): void {
        if (this._sdk) {
            try {
                this._sdk.gameplayStart();
            } catch (e) {
            }
        }
    }

    public gameplayStop(): void {
        if (this._sdk) {
            try {
                this._sdk.gameplayStop();
            } catch (e) {
            }
        }
    }

    private _adsStarted(): void {
        if (this.onStarted) {
            this.onStarted();
        }
    }

    private _adsFinished(): void {
        if (this.onFinished) {
            this.onFinished();
        }
    }

    private _adsError(props): void {
        console.error('ad error', props);
        if (this.onError) {
            this.onError(props);
        }
    }

    private _adsBannerRendered(event): void {
        console.log(`banner for container ${event.containerId} has been rendered!`);

        if (this.onError) {
            this.onError();
        }
    }

    private _adsBannerError(event): void {
        console.log(`banner render error: ${event.error}`);

        if (this.onError) {
            this.onError();
        }
    }

    private _adblockDetection(event): void {
        this.hasAdBlock = event.hasAdblock;
    }
}
